import { ThemeFamilies } from './types';
var getToast = function (colors) {
    var _a;
    return (_a = {},
        _a[ThemeFamilies.INFO] = {
            main: colors.info,
            light: colors.surfaceFamilies.highlights,
            text: colors.secondaryText,
        },
        _a[ThemeFamilies.ERROR] = {
            main: colors.error,
            light: colors.surfaceFamilies.error,
            text: colors.secondaryText,
        },
        _a[ThemeFamilies.SUCCESS] = {
            main: colors.success,
            light: colors.surfaceFamilies.success,
            text: colors.secondaryText,
        },
        _a[ThemeFamilies.WARNING] = {
            main: colors.warning,
            light: colors.surfaceFamilies.warning,
            text: colors.secondaryText,
        },
        _a);
};
export default getToast;
